export const CUSTOM_FIELD_EDIT_MODULE_ID = 'custom-field-edit-module';

export const LOAD_CUSTOM_FIELD_EDIT_MODULE = () =>
  import('@capital-access/custom-fields/edit').then(m => m.CustomFieldsEditModule);
